import '../style/VisionMission.css';

export default function VisionMission() {
  return (
    <section className="vision-mission" aria-label="Vision and Mission">
      <div className="vision-mission-card">
        <div className="vision-mission-layout">
          <div className="vision-mission-media" aria-hidden="true">
            <img
              className="vision-mission-image"
              src={`${process.env.PUBLIC_URL}/image/nne.jpeg`}
              alt=""
              loading="lazy"
            />
          </div>

          <article className="vm-why">
            <p className="vision-mission-kicker">Why Choose Us</p>
            <h2 className="vision-mission-title">
              Reliable Logistics Built Around Your Business
            </h2>
            <p className="vm-why-description">
              We deliver dependable, efficient, and tailored logistics services
              that help businesses move cargo confidently across local and
              international routes. With strong operational control, experienced
              teams, and customer-first execution, we simplify your supply chain
              from pickup to final delivery.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

